import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getHospital = createAsyncThunk(
  "hospital/getHospital",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.getHospital(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const hospitalSlice = createSlice({
  name: "hospital",
  initialState,
  reducers: {
    setHospitalList(state, action) {
      state.value = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHospital.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHospital.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getHospital.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const hospital = (state) => state.hospital.value;
export const hospitalObjLoader = (state) => state.hospital.loading;
export const { setHospitalList } = hospitalSlice.actions;

export default hospitalSlice.reducer;
